import produce from 'immer';
import { includes } from 'lodash';
import { handleActions } from 'redux-actions';
import actions from './actions';
import { _LIST_PAGINATION_MODEL } from '../app/models';
import {
  TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
  TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_OPTION_MODEL,
  TAG_GROUP_LIST_SEARCH_DATA_MODEL,
  TAG_GROUP_LIST_SORT_OPTION_MODEL,
  TAG_LIST_SEARCH_DATA_MODEL,
  TAG_LIST_SEARCH_OPTION_MODEL,
  TAG_LINK_LIST_MODEL,
  TAG_INFO_MODEL,
} from './models';
import {
  TAG_RELATED_ITEM_TYPE,
  TAG_TAB_MAIN_SECTION_TYPE,
  TAG_TAB_MAIN_SECTION_TYPE_LIST,
  TAG_TREND_KEYWORD_SECTION_TYPE,
  TAG_TREND_KEYWORD_SECTION_TYPE_LIST,
  TAG_GROUP_TYPE,
} from '../../../constants/service/app/tagConstants';
import { getDifferenceList, setUncheckableTableTransferList, updateStoreWithPath } from '../../../lib/common';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  태그 등록/편집
   */
  tagEdit: {
    /**
     *  태그 정보
     */
    tagInfo: TAG_INFO_MODEL,
    /**
     *  태그 탭 메인 아이템 리스트
     */
    tagTabMain: {
      itemList: [],
      selectedItemList: {
        list: [],
        idList: [],
      },
    },
    /**
     *  태그 검색 리스트 SELECT
     */
    tagSearchSelectList: [],
    /**
     *  추천 태그 리스트 SELECT
     */
    recommendTagSelectList: [],
  },

  /**
   *  태그 상세 내역
   */
  tagHistory: {
    /**
     *  태그 정보
     */
    tagInfo: {
      /**
       *  태그 id
       */
      tagId: null,
      /**
       *  태그명
       */
      tagName: null,
      /**
       *  태그 상태
       */
      status: null,
      /**
       *  상품 카테고리 연결 여부
       */
      connectedProductCategory: null,
      /**
       *  태그 그룹 리스트
       */
      tagGroupList: [],
      /**
       *  연관 태그 리스트
       */
      relatedTagList: [],
      /**
       *  태그 이미지
       */
      tagImg: [],
      /**
       *  태그 등록일
       */
      createDate: null,
      /**
       *  태그 최종 수정일
       */
      updateDate: null,
    },
    /**
     *  활동 내역
     */
    activityHistory: {
      /**
       *  유저 태그 팔로워 수
       */
      userFollowerCount: null,
      /**
       *  클릭 수 (조회)
       */
      clickCount: null,
      /**
       *  검색 수 (조회)
       */
      searchCount: null,
      /**
       *  태그 메인 탭 트렌드 키우드 리스트 노출 여부
       */
      isUsedTagTabMainTrendKeywordList: false,
      /**
       *  태그 메인 탭 팔로우한 리스트 노출 여부
       */
      isUsedTagTabMainSelectedFollowList: false,
      /**
       *  태그 트렌드 키워드 top 30 노출 여부
       */
      isUsedTagTrendKeywordTopRankList: false,
      /**
       *  태그 트렌드 키워드 스타일별 노출 여부
       */
      isUsedTagTrendKeywordStyleList: false,
      /**
       *  태그 트렌드 키워드 태그모아보기 노출 여부
       */
      isUsedTagTrendKeywordCollectionList: false,
    },
    /**
     *  태그에 연결된 아이템 리스트
     */
    relatedItemList: {
      /**
       *  태그에 연결된 상품 리스트
       */
      [TAG_RELATED_ITEM_TYPE.PRODUCT]: {
        /**
         *  리스트
         */
        list: [],
        /**
         *  검색 박스
         */
        searchData: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
        /**
         *  검색 옵션
         */
        searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_OPTION_MODEL,
        /**
         *  리스트 pagination
         */
        pagination: _LIST_PAGINATION_MODEL,
      },
      /**
       *  태그에 연결된 브랜드 리스트
       */
      [TAG_RELATED_ITEM_TYPE.STORE]: {
        /**
         *  리스트
         */
        list: [],
        /**
         *  검색 박스
         */
        searchData: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
        /**
         *  검색 옵션
         */
        searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_OPTION_MODEL,
        /**
         *  리스트 pagination
         */
        pagination: _LIST_PAGINATION_MODEL,
      },
      /**
       *  태그에 연결된 기획전 리스트
       */
      [TAG_RELATED_ITEM_TYPE.EVENT]: {
        /**
         *  리스트
         */
        list: [],
        /**
         *  검색 박스
         */
        searchData: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
        /**
         *  검색 옵션
         */
        searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_OPTION_MODEL,
        /**
         *  리스트 pagination
         */
        pagination: _LIST_PAGINATION_MODEL,
      },
      /**
       *  태그에 연결된 상품 후기 리스트
       */
      [TAG_RELATED_ITEM_TYPE.REVIEW]: {
        /**
         *  리스트
         */
        list: [],
        /**
         *  검색 박스
         */
        searchData: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
        /**
         *  검색 옵션
         */
        searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_OPTION_MODEL,
        /**
         *  리스트 pagination
         */
        pagination: _LIST_PAGINATION_MODEL,
      },
    },
  },

  /**
   *  태그 리스트
   */
  tagList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: TAG_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: TAG_LIST_SEARCH_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },

  /**
   *  태그 그룹 SELECT 리스트
   */
  tagGroupSelectList: [],

  /**
   *  태그 그룹 등록/편집
   */
  tagGroupEdit: {
    /**
     *  태그 그룹 정보
     */
    tagGroupInfo: {
      /**
       *  태그 그룹 id
       */
      tagGroupId: null,
      /**
       *  태그 그룹명
       */
      tagGroupName: null,
      /**
       *  태그 그룹명 중복 여부
       */
      isDuplicationTagGroupName: false,
      /**
       *  태그 그룹 타입
       */
      tagGroupType: TAG_GROUP_TYPE.GENERAL,
    },
    /**
     *  태그 그룹에 연결된 아이템
     */
    tagGroupItem: TAG_LINK_LIST_MODEL,
    /**
     *  태그 그룹 수정 가능여부
     */
    editableTagGroup: true,
  },

  /**
   *  태그 그룹 리스트
   */
  tagGroupList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: TAG_GROUP_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: TAG_GROUP_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },

  /**
   *  태그 탭 메인 관리
   */
  tagTabMain: {
    /**
     *  트렌드 키워드 리스트
     */
    [TAG_TAB_MAIN_SECTION_TYPE.TAG_TEND_KEYWORD_LIST]: TAG_LINK_LIST_MODEL,
    /**
     *  미리 선정된 팔로우한 태그 리스트
     */
    [TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST]: TAG_LINK_LIST_MODEL,
  },

  /**
   *  태그 트렌드 키워드 관리
   */
  tagTrendKeyword: {
    /**
     *  top 30 추천 태그 리스트
     */
    [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_TOP_RANK_LIST]: TAG_LINK_LIST_MODEL,
    /**
     *  스타일별 추천 태그 리스트
     */
    [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST]: TAG_LINK_LIST_MODEL,
    /**
     *  태그 모아보기 추천 태그 리스트
     */
    [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_COLLECTION_LIST]: TAG_LINK_LIST_MODEL,
  },

  /**
   *  태그 탭 메인 미리보기 모달
   */
  tagTabMainPreviewModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  태그 탭 메인 편집하기 모달
   */
  editTabMainModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  태그 트렌드 키워드 미리보기 모달
   */
  tagTrendKeywordPreviewModal: {
    isOpen: false,
    data: {},
  },

  /**
   *  태그 트렌드 키워드 편집하기 모달
   */
  editTrendKeywordModal: {
    isOpen: false,
    data: {},
  },
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  태그 데이터 변경하기 성공
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  태그 등록하기 전 필요한 데이터 가져오기 성공
     */
    [actions.PREPARE_INSERT_TAG_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagGroupSelectList = action.payload.tagGroupSelectList;
      });
    },

    /**
     *  태그명 중복검사 요청하기 성공
     */
    [actions.CHECK_TAG_NAME_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagEdit.tagInfo.isDuplicationTagName = action.payload.isDuplication;
      });
    },

    /**
     *  태그 검색 리스트 요청하기 성공
     */
    [actions.GET_TAG_SEARCH_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagEdit.tagSearchSelectList = action.payload.tagSearchSelectList;
      });
    },

    /**
     *  추천 태그 리스트 요청하기 성공
     */
    [actions.GET_RECOMMEND_TAG_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagEdit.recommendTagSelectList = getDifferenceList(
          action.payload.tagSearchSelectList,
          draft.tagEdit.tagInfo.relatedTagList,
          'id',
          'id',
        );

        if (!draft.tagEdit.recommendTagSelectList.length) {
          draft.tagEdit.recommendTagSelectList = null;
        }
      });
    },

    /**
     *  태그 리스트 요청하기 성공
     */
    [actions.GET_TAG_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        if (action.payload.tagGroupSelectList && action.payload.tagGroupSelectList.length) {
          draft.tagGroupSelectList = action.payload.tagGroupSelectList;
        }

        draft.tagList = {
          ...draft.tagList,
          ...action.payload.tagList,
        };
      });
    },

    /**
     *  태그 상세 내역 요청하기 성공
     */
    [actions.GET_TAG_HISTORY_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  태그 상세
         */
        draft.tagHistory.tagInfo = action.payload.tagHistory.tagInfo;
        draft.tagHistory.activityHistory = action.payload.tagHistory.activityHistory;
        draft.tagHistory.relatedItemList[TAG_RELATED_ITEM_TYPE.PRODUCT] = {
          ...draft.tagHistory.relatedItemList[TAG_RELATED_ITEM_TYPE.PRODUCT],
          ...action.payload.tagHistory.relatedProductList,
        };
        draft.tagHistory.relatedItemList[TAG_RELATED_ITEM_TYPE.STORE] = {
          ...draft.tagHistory.relatedItemList[TAG_RELATED_ITEM_TYPE.STORE],
          ...action.payload.tagHistory.relatedStoreList,
        };
        draft.tagHistory.relatedItemList[TAG_RELATED_ITEM_TYPE.EVENT] = {
          ...draft.tagHistory.relatedItemList[TAG_RELATED_ITEM_TYPE.EVENT],
          ...action.payload.tagHistory.relatedEventList,
        };
        draft.tagHistory.relatedItemList[TAG_RELATED_ITEM_TYPE.REVIEW] = {
          ...draft.tagHistory.relatedItemList[TAG_RELATED_ITEM_TYPE.REVIEW],
          ...action.payload.tagHistory.relatedReviewList,
        };
      });
    },

    /**
     *  태그 상세 내역에 연결된 아이템 리스트 요청하기 성공
     */
    [actions.GET_TAG_HISTORY_RELATED_ITEM_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagHistory.relatedItemList[action.payload.tagRelatedItemType] = {
          ...draft.tagHistory.relatedItemList[action.payload.tagRelatedItemType],
          ...action.payload.relatedItemList,
        };
      });
    },

    /**
     *  태그 그룹명 중복검사 요청하기 성공
     */
    [actions.CHECK_TAG_GROUP_NAME_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagGroupEdit.tagGroupInfo.isDuplicationTagGroupName = action.payload.isDuplication;
      });
    },

    /**
     *  태그 그룹에 연결할 아이템 리스트 요청하기 성공
     */
    [actions.GET_TAG_GROUP_ITEM_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagGroupEdit.tagGroupItem.itemList = {
          ...draft.tagGroupEdit.tagGroupItem.itemList,
          ...action.payload.tagGroupItem,
        };

        /**
         *  받아온 태그 그룹 아이템 중에 이미 설정된 태그 그룹 아이템인 경우에는
         *  태그 그룹 아이템 선택 부분에서 이동을 할 수 없도록 하기
         */
        draft.tagGroupEdit.tagGroupItem.itemList.list = draft.tagGroupEdit.tagGroupItem.itemList.list.map((item) => ({
          ...item,
          uncheckable: includes(state.tagGroupEdit.tagGroupItem.selectedItemList.idList, item.id) || item.uncheckable,
        }));
      });
    },

    /**
     *  태그 그룹 리스트 요청하기 성공
     */
    [actions.GET_TAG_GROUP_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagGroupList = {
          ...draft.tagGroupList,
          ...action.payload.tagGroupList,
        };
      });
    },

    /**
     *  태그 그룹 상세 요청하기 성공
     */
    [actions.GET_TAG_GROUP_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagGroupEdit.tagGroupInfo = {
          ...draft.tagGroupEdit.tagGroupInfo,
          ...action.payload.tagGroupDetail.tagGroupInfo,
        };

        draft.tagGroupEdit.tagGroupItem.selectedItemList = action.payload.tagGroupDetail.tagGroupItem.selectedItemList;

        draft.tagGroupEdit.editableTagGroup = action.payload.tagGroupDetail.editableTagGroup;
      });
    },

    /**
     *  태그 상세 요청하기 성공
     */
    [actions.GET_TAG_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  태그 상세
         */
        draft.tagEdit.tagInfo = action.payload.tagDetail.tagInfo;

        /**
         *  태그 탭 메인 아이템 리스트
         */
        draft.tagEdit.tagTabMain = {
          itemList: action.payload.tagRelatedProductAndReviewList,
          selectedItemList: {
            list: action.payload.tagTabMainContentList,
            idList: action.payload.tagTabMainContentList.map((item) => item.id),
          },
        };

        /**
         *  업로드 아이템 중에 선택된 태그 아이템인 경우에는
         *  태그 아이템 선택 부분에서 이동을 할 수 없도록 하기
         */
        draft.tagEdit.tagTabMain.itemList = setUncheckableTableTransferList({
          list: draft.tagEdit.tagTabMain.itemList,
          selectedIdList: draft.tagEdit.tagTabMain.selectedItemList.idList,
        });

        /**
         *  태그 그룹 SELECT 리스트
         */
        draft.tagGroupSelectList = action.payload.tagGroupSelectList;
      });
    },

    /**
     *  태그 탭 메인 데이터 요청하기 성공
     */
    [actions.GET_TAG_TAB_MAIN_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        TAG_TAB_MAIN_SECTION_TYPE_LIST.forEach((sectionType) => {
          /**
           *  태그 탭 메인에 연결할 컨텐츠 리스트
           */
          draft.tagTabMain[sectionType].itemList = {
            ...draft.tagTabMain[sectionType].itemList,
            ...action.payload.activeTagList,
          };

          /**
           *  선택된 태그 탭 메인에 연결된 컨텐츠 리스트
           */
          draft.tagTabMain[sectionType].selectedItemList = {
            list: action.payload[sectionType],
            idList: action.payload[sectionType].map((item) => item.id),
          };

          /**
           *  받아온 태그 탭 메인에 연결할 컨텐츠 리스트 중에 이미 선택된 태그인 경우에는
           *  태그 탭 메인에 연결할 컨텐츠 리스트 선택 부분에서 이동을 할 수 없도록 하기
           */
          draft.tagTabMain[sectionType].itemList.list = draft.tagTabMain[sectionType].itemList.list.map((item) => ({
            ...item,
            uncheckable: includes(draft.tagTabMain[sectionType].selectedItemList.idList, item.id) || item.uncheckable,
          }));
        });
      });
    },

    /**
     *  태그 탭 메인에 연결할 컨텐츠 리스트 요청하기 성공
     */
    [actions.GET_TAG_TAB_MAIN_CONTENTS_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagTabMain[action.payload.tagTabMainSectionType].itemList = {
          ...draft.tagTabMain[action.payload.tagTabMainSectionType].itemList,
          ...action.payload.activeTagList,
        };

        /**
         *  받아온 태그 탭 메인에 연결할 컨텐츠 리스트 중에 이미 선택된 태그인 경우에는
         *  태그 탭 메인에 연결할 컨텐츠 리스트 선택 부분에서 이동을 할 수 없도록 하기
         */
        draft.tagTabMain[action.payload.tagTabMainSectionType].itemList.list = draft.tagTabMain[
          action.payload.tagTabMainSectionType
        ].itemList.list.map((item) => ({
          ...item,
          uncheckable:
            includes(state.tagTabMain[action.payload.tagTabMainSectionType].selectedItemList.idList, item.id) ||
            item.uncheckable,
        }));
      });
    },

    /**
     *  태그 트렌드 키워드데이터 요청하기 성공
     */
    [actions.GET_TREND_KEYWORD_DATA_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        TAG_TREND_KEYWORD_SECTION_TYPE_LIST.forEach((sectionType) => {
          /**
           *  태그 트렌드 키워드에 연결할 컨텐츠 리스트
           */
          draft.tagTrendKeyword[sectionType].itemList = {
            ...draft.tagTrendKeyword[sectionType].itemList,
            ...action.payload.activeTagList,
          };

          /**
           *  선택된 트렌드 키워드에 연결된 컨텐츠 리스트
           */
          draft.tagTrendKeyword[sectionType].selectedItemList = {
            list: action.payload[sectionType],
            idList: action.payload[sectionType].map((item) => item.id),
          };

          /**
           *  받아온 태그 트렌드 키워드에 연결할 컨텐츠 리스트 중에 이미 선택된 태그인 경우에는
           *  태그 트렌드 키워드에 연결할 컨텐츠 리스트 선택 부분에서 이동을 할 수 없도록 하기
           */
          draft.tagTrendKeyword[sectionType].itemList.list = draft.tagTrendKeyword[sectionType].itemList.list.map(
            (item) => ({
              ...item,
              uncheckable:
                includes(draft.tagTrendKeyword[sectionType].selectedItemList.idList, item.id) || item.uncheckable,
            }),
          );
        });
      });
    },

    /**
     *  태그 트렌드 키워드에 연결할 컨텐츠 리스트 요청하기 성공
     */
    [actions.GET_TAG_TREND_KEYWORD_CONTENTS_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.tagTrendKeyword[action.payload.tagTrendKeywordSectionType].itemList = {
          ...draft.tagTrendKeyword[action.payload.tagTrendKeywordSectionType].itemList,
          ...action.payload.activeTagList,
        };

        /**
         *  받아온 태그 탭 메인에 연결할 컨텐츠 리스트 중에 이미 선택된 태그인 경우에는
         *  태그 탭 메인에 연결할 컨텐츠 리스트 선택 부분에서 이동을 할 수 없도록 하기
         */
        draft.tagTrendKeyword[action.payload.tagTrendKeywordSectionType].itemList.list = draft.tagTrendKeyword[
          action.payload.tagTrendKeywordSectionType
        ].itemList.list.map((item) => ({
          ...item,
          uncheckable:
            includes(
              state.tagTrendKeyword[action.payload.tagTrendKeywordSectionType].selectedItemList.idList,
              item.id,
            ) || item.uncheckable,
        }));
      });
    },

    /**
     *  [태그 그룹 등록/편집] 태그 아이템 EXCEL 업로드하기 성공
     */
    [actions.SET_TAG_GROUP_EXCEL_UPLOAD_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  연결된 태그 리스트 업데이트
         */
        draft.tagGroupEdit.tagGroupItem.selectedItemList.list = action.payload.itemList;
        draft.tagGroupEdit.tagGroupItem.selectedItemList.idList =
          draft.tagGroupEdit.tagGroupItem.selectedItemList.list.map((item) => item.id);

        /**
         *  업로드 아이템 중에 선택된 태그 아이템인 경우에는
         *  태그 아이템 선택 부분에서 이동을 할 수 없도록 하기
         */
        draft.tagGroupEdit.tagGroupItem.itemList.list = setUncheckableTableTransferList({
          list: draft.tagGroupEdit.tagGroupItem.itemList.list,
          selectedIdList: draft.tagGroupEdit.tagGroupItem.selectedItemList.idList,
        });
      });
    },

    /**
     *  [태그 메인 탭 관리] 태그 아이템 EXCEL 업로드하기 성공
     */
    [actions.SET_TAG_TAB_MAIN_EXCEL_UPLOAD_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        const { itemList, tagTabMainSectionType } = action.payload;

        /**
         *  연결된 태그 리스트 업데이트
         */
        draft.tagTabMain[tagTabMainSectionType].selectedItemList.list = itemList;
        draft.tagTabMain[tagTabMainSectionType].selectedItemList.idList = draft.tagTabMain[
          tagTabMainSectionType
        ].selectedItemList.list.map((item) => item.id);

        /**
         *  업로드 아이템 중에 선택된 태그 아이템인 경우에는
         *  태그 아이템 선택 부분에서 이동을 할 수 없도록 하기
         */
        draft.tagTabMain[tagTabMainSectionType].itemList.list = setUncheckableTableTransferList({
          list: draft.tagTabMain[tagTabMainSectionType].itemList.list,
          selectedIdList: draft.tagTabMain[tagTabMainSectionType].selectedItemList.idList,
        });
      });
    },

    /**
     *  [태그 트렌드 키워드 관리] 태그 아이템 EXCEL 업로드하기 성공
     */
    [actions.SET_TAG_TREND_KEYWORD_EXCEL_UPLOAD_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        const { itemList, tagTrendKeywordSectionType } = action.payload;

        /**
         *  연결된 태그 리스트 업데이트
         */
        draft.tagTrendKeyword[tagTrendKeywordSectionType].selectedItemList.list = itemList;
        draft.tagTrendKeyword[tagTrendKeywordSectionType].selectedItemList.idList = draft.tagTrendKeyword[
          tagTrendKeywordSectionType
        ].selectedItemList.list.map((item) => item.id);

        /**
         *  업로드 아이템 중에 선택된 태그 아이템인 경우에는
         *  태그 아이템 선택 부분에서 이동을 할 수 없도록 하기
         */
        draft.tagTrendKeyword[tagTrendKeywordSectionType].itemList.list = setUncheckableTableTransferList({
          list: draft.tagTrendKeyword[tagTrendKeywordSectionType].itemList.list,
          selectedIdList: draft.tagTrendKeyword[tagTrendKeywordSectionType].selectedItemList.idList,
        });
      });
    },

    /**
     *  모달 토글
     */
    [actions.TOGGLE_MODAL]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath([action.payload.name, 'data'], action.payload.data, draft);
        updateStoreWithPath([action.payload.name, 'isOpen'], action.payload.value, draft);
      });
    },
  },
  initialState,
);
